/* P073205 only; unpublished QA-stage checks. Requires the draft form's
 * value/File-object approval snapshots. Local readability is not print-quality,
 * supplier-format or server-side upload validation. No file is uploaded here.
 */
(() => {
  'use strict';
  if (window.hfP073205PhotoGuardLoaded) return;
  window.hfP073205PhotoGuardLoaded = true;
  const VARIANT = '53731962323282';
  const PROPERTY = 'properties[Image]';
  function attach(pf) {
    if (!pf.form || pf.form.querySelector('[name="id"]')?.value !== VARIANT || pf.hfTapePhotoGuard) return;
    if (typeof pf.personalisationApprovalMatches !== 'function' ||
        typeof pf.getPersonalisationFieldError !== 'function' ||
        typeof pf.validatePersonalisation !== 'function' || !pf.personalisationApprovals) return;
    pf.hfTapePhotoGuard = true;
    const states = new WeakMap();
    const originalError = pf.getPersonalisationFieldError;
    const originalValidate = pf.validatePersonalisation;
    const controls = () => Array.from(pf.form.querySelectorAll('[data-personalisation-input][type="file"]'));
    const hasRetainedPhoto = (field) => {
      if (pf.getAttribute('data-hf-edit-mode') !== 'true' || !field.disabled ||
          field.files.length || !field.dataset.hfRetainedPhoto) return false;
      try {
        const photo = new URL(field.dataset.hfRetainedPhoto, window.location.origin);
        return (photo.protocol === 'https:' || photo.protocol === 'http:') &&
          (photo.hostname === 'cdn.shopify.com' || photo.origin === window.location.origin) &&
          photo.pathname.includes('/uploads/');
      } catch {
        return false;
      }
    };
    function inspect(file, field) {
      let state = states.get(file);
      if (state) return state;
      state = { status: 'pending' };
      states.set(file, state);
      const image = new Image();
      const url = URL.createObjectURL(file);
      let done = false;
      const finish = (readable) => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        image.onload = image.onerror = null;
        URL.revokeObjectURL(url);
        state.status = readable ? 'ready' : 'invalid';
        if (field.isConnected && field.files?.[0] === file) {
          pf.syncPersonalisationControl(field);
          const status = field.closest('[data-personalisation-item]')?.querySelector('[data-personalisation-file-status]');
          if (status) status.textContent = readable
            ? `${file.name}: image can be opened. Please check that it is the intended photograph.`
            : 'This image cannot be opened. Please choose another photo.';
        }
      };
      const timer = setTimeout(() => finish(false), 15000);
      image.onload = () => finish(image.naturalWidth > 0 && image.naturalHeight > 0);
      image.onerror = () => finish(false);
      image.src = url;
      return state;
    }
    pf.getPersonalisationFieldError = function (field) {
      if (field.type === 'file' && field.name === PROPERTY && hasRetainedPhoto(field)) return '';
      const base = originalError.call(this, field);
      if (base || field.type !== 'file' || field.name !== PROPERTY) return base;
      if (field.files.length !== 1) return 'Please select exactly one photograph for this tape measure.';
      const file = field.files[0];
      if (!file.size) return 'This photo file is empty. Please choose another photo.';
      const state = inspect(file, field);
      if (state.status === 'pending') return 'Checking your photo. Please try again when the image check finishes.';
      if (state.status !== 'ready') return 'This image cannot be opened. Please choose another photo.';
      return '';
    };
    pf.validatePersonalisation = function (...args) {
      const photos = controls();
      const propControls = Array.from(this.form.elements).filter((field) => field.name === PROPERTY);
      if (photos.length !== 1 || propControls.length !== 1 || photos[0] !== propControls[0] ||
          (!hasRetainedPhoto(photos[0]) &&
            (photos[0].disabled || !photos[0].hasAttribute('data-personalisation-required')))) {
        this.showPersonalisationError(photos[0] || this.submitButton,
          'The photo field is unavailable. Please reload this product page before ordering.');
        return false;
      }
      return originalValidate.apply(this, args);
    };
    pf.form.querySelectorAll('[data-personalisation-confirmation]').forEach((confirmation) => {
      confirmation.checked = false;
      pf.personalisationApprovals.delete(confirmation);
      confirmation.dataset.personalisationConfirmationMode = 'photo';
      confirmation.dataset.errorMessage = 'Please confirm that you have checked your photograph and any wording.';
      const text = confirmation.closest('label')?.querySelector('span');
      if (text) text.textContent = 'I have checked my photograph and any wording.';
    });
    controls().forEach((field) => {
      const check = () => pf.getPersonalisationFieldError(field);
      field.addEventListener('input', check);
      field.addEventListener('change', check);
      if (field.files.length) check();
    });
    pf.syncPersonalisationConfirmationState();
  }
  customElements.whenDefined('product-form').then(() => {
    document.querySelectorAll('product-form').forEach(attach);
    new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches('product-form')) attach(node);
      node.querySelectorAll('product-form').forEach(attach);
    }))).observe(document.body, { childList: true, subtree: true });
  });
})();
